module.exports = __webpack_public_path__ + "images/Beyond_Meat-4b4ab2.png";